import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../utils/analytics';

/**
 * PageViewTracker component
 * Automatically tracks page views when routes change
 * Should be placed inside Router but outside Routes
 */
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    const page = location.pathname + location.search + location.hash;
    analyticsService.trackPageView(page);

    // Also send to gtag directly for redundancy
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: page,
        page_title: document.title,
        page_location: window.location.href
      });
    }

    // Log for debugging in development
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Page view tracked:', page);
    }
  }, [location]);

  return null; // This component doesn't render anything
}

export default PageViewTracker;
